import type { ComboboxItem } from "@mantine/core";
import { useCallback } from "react";
import { useSelector } from "src/redux/hooks";

import CustomSelect from "../CustomSelect/CustomSelect";

interface Props {
  id: string;
  value: string;
  required: boolean;
}

const Bioareas = (props: Props) => {
  const yachtdata = useSelector(state => state.generatorSlice.yachtData);

  const getData = useCallback(() => {
    const data: ComboboxItem[] = [];
    if (yachtdata?.biofoul?.areas) {
      yachtdata.biofoul.areas.forEach(section => {
        section.list.forEach((item: any) => {
          data.push({
            group: section.section,
            value: item.name,
            label: item.name,
            inputLabel: section.section,
          });
        });
      });
    }

    return data;
  }, [yachtdata?.biofoul?.areas]);

  return (
    <CustomSelect
      {...props}
      data={getData()}
      styles={{ input: { width: "100px" } }}
      withLabel
    />
  );
};

export default Bioareas;
